const preRequestError = (error) =>
  Object.assign(new Error(error?.message || "Survey request preparation failed"), {
    cause: error,
    originalError: error,
    requestSent: false,
    safeToContinue: true,
    persistenceState: "source",
  });

export const surveyApiClient = ({ httpClient, httpClientAuthorizer, keycloakIDPAdapter }) =>
  async function request({
    method,
    url,
    body,
    data,
    hash,
    mode = "default", // "default" | "resolution" | "sequence"
    ignoreError,
    ignoreLoader = false,
    isFirstStep,
    isLastStep,
    onSuccess,
    onError,
    tokenUpdate = true,
    noCompanyHashHeader = false,
  }) {
    let baseConfig;
    try {
      if (tokenUpdate) await keycloakIDPAdapter.getClient().updateToken(0);
      const companyhash = noCompanyHashHeader ? undefined : hash;
      baseConfig = httpClientAuthorizer.authorizeRequestBenchmarkingConfig(
        keycloakIDPAdapter,
        companyhash ? { headers: { companyhash } } : { headers: {} }
      );
    } catch (error) {
      throw preRequestError(error);
    }
    const payload = {
      method,
      url,
      data: body ?? data,
      config: { ...baseConfig },
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (err) => onError?.(err),
      ignoreError,
      ignoreLoader,
      isFirstStep,
      isLastStep,
    };

    if (mode === "resolution") return httpClient.requestWithResolution(payload);
    if (mode === "sequence") return httpClient.fetchInSequence(payload);
    return httpClient.request(payload);
  };
